<template>
  <div>
    <div class="input-group-prepend search-icon-container">
      <span class="input-group-text" @click="submitSearch()"><img :src="searchIcon"/></span>
      <vue-autosuggest
        class="search-input"
        ref="autosuggest"
        :suggestions="filteredOptions"
        @selected="onSelected"
        @keydown.tab.prevent="tabHandler"
        @keydown.enter.prevent="submitSearch"
        :get-suggestion-value="getSuggestionValue"
        :input-props="inputProps"
        :limit="5" >
        <template slot-scope="{suggestion}">
          <div v-html="renderResultText(suggestion.item)"></div>
        </template>
      </vue-autosuggest>
      <button v-if="this.route === 'searchView'"  class="close close-btn" @click="closeDetailView()">
        <font-awesome-icon icon="times"/>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { VueAutosuggest } from 'vue-autosuggest'
import * as CONSTANTS from '../constants.js'
import AppHandlerMixin from "@/mixins/AppHandlerMixin";
import SearchIcon from '../assets/search-icon.svg'

export default {
  name: 'SearchFilter',
  mixins: [AppHandlerMixin],
  components: {
    VueAutosuggest
  },
  props: {
    route: String
  },
  data: function () {
    return {
      CONSTANTS,
      searchText: '',
      filteredOptions: [],
      searchIcon : SearchIcon,
      inputProps: {
        id: 'autosuggest__input',
        onInputChange: this.onInputChange,
        placeholder: 'Search applications, sites, and downloads'
      }
    }
  },
  computed: {
    ...mapGetters(['getApplications', 'getPreviousRoute']),
    suggestions: function () {
      var suggestions = [
        {
          data: this.getApplications
        }
      ]
      return suggestions
    }
  },
  mounted () {},
  methods: {
    onInputChange (text, oldText) {
      this.searchText = text
      if (!text || /^\s*$/.test(text)) {
        this.filteredOptions = [{ data: [] }]
        return
      }
      var filteredData = this.suggestions[0].data.filter(option => {
        return option.title.toLowerCase().indexOf(text.toLowerCase()) > -1
      })
      this.filteredOptions = [{ data: filteredData }]
    },
    closeDetailView() {
      // if previous path is a detail view, route to home
      if (this.getPreviousRoute.fullPath.includes("/view-app/") || 
          this.getPreviousRoute.fullPath.includes("/search")) {
        this.$router.push({ path: "/" });
      } else {
        this.$router.push({ path: this.getPreviousRoute.fullPath });
      }
    },
    onSelected (selected) {
      if (selected) {
        this.clearSearch()
        this.$router.push({ path: '/view-app/' + selected.item.id })
      }
    },
    getSuggestionValue (suggestion) {
      return suggestion.item.title
    },
    renderResultText (item) {
      let tmp = '<img style="width: 20px; margin-right: 7px;" src="'+this.getAppIcon(item)+'">'
      var re = new RegExp(this.searchText, 'ig')
      //regex match and replace character
      return tmp + item.title.replace(re, '<b>$&</b>')
    },
    /**
     * Override tab default. Select first indexed suggestion.
     */
    tabHandler () {
      const { listeners, setCurrentIndex, setChangeItem, getItemByIndex } = this.$refs.autosuggest
      setCurrentIndex(0)
      setChangeItem(getItemByIndex(this.$refs.autosuggest.currentIndex), true)
      this.$refs.autosuggest.loading = true
      listeners.selected(true)
    },
    submitSearch () {
      if (this.searchText) {        
        let st = this.searchText.replace(/[^\w\s]/gi, '')
        st = st.trim();
        this.$router.push({ path: '/search?q=' + st})
      }
      this.clearSearch()
    },
    clearSearch () {
      this.searchText = ''
      this.$refs.autosuggest.searchInput = ''
      this.filteredOptions = [{ data: [] }]
      this.$refs.autosuggest.currentItem = null
    }
  }
}
</script>
<style scoped>
.close-btn {
  position: absolute;
  right: 30px;
  top: 0px;
  height: 100%;
  color: #FFFFFF;
  opacity: 1;
}
.close-btn:hover {
  opacity: .75;
  color: #FFFFFF;
}
.close-btn svg {
  height: 20px;
}
.input-group-text img {
  width : 22px;
}
@media(max-width: 1200px) {
  .close-btn {
    position: absolute;
    right: 25px;
    top: -3px;
    height: 100%;
  }
}
</style>

